import { BsInfoCircle } from "react-icons/bs";
import { InfoBub } from './style.button';

const InfoBubBtn = (props) => {
    return (
        <InfoBub hideInfo={props.hideInfo}><BsInfoCircle /></InfoBub>
    );
}

export default InfoBubBtn;